import { useDispatch } from "react-redux";
import { CONTRACT_MODAL_ACTION_TYPE } from "../../../../redux/actions-type";

const Status = ({ modalData }) => {
  const dispatch = useDispatch();

  const handleChange = (isActive) => {
    dispatch({
      type: CONTRACT_MODAL_ACTION_TYPE.GET_CONTRACT_MODAL,
      payload: {
        data: { ...modalData, isActive },
        openModal: true,
      },
    });
  };

  return (
    <ul className="modal-status">
      <li
        className={`${modalData.isActive ? "active" : ""}`}
        onClick={() => handleChange(true)}
      >
        Aktiv
      </li>
      <li
        className={`${modalData.isActive ? "" : "active"}`}
        onClick={() => handleChange(false)}
      >
        Deaktiv
      </li>
    </ul>
  );
};

export default Status;
